// FORGE Coming-Soon + Landing — Hinweis auf die kostenlose Beta (22.09.2026)
//
// Rainer: „Kunden, die sich vom 01.10. bis 31.10. anmelden, sind automatisch
// Beta-Kunden … Coming-Soon sollte es schon anzeigen." Die Daten stehen NUR in
// der Datenbank (beta_programm, im CRM gepflegt) und kommen über
// forge_beta_programm() (für anon freigegeben). Kein Datum im Quelltext: ändert
// Rainer das Fenster im CRM, stimmt die Seite ohne Deploy.
//
// Angezeigt wird nur, solange das Fenster bevorsteht oder offen ist. Fehlt die
// Antwort, bleibt der Block weg — kein Rückfalltext mit geratenen Daten.

export async function ladeBetaProgramm(sbUrl, sbKey) {
  try {
    const res = await fetch(sbUrl + '/rest/v1/rpc/forge_beta_programm', {
      method: 'POST',
      headers: { apikey: sbKey, Authorization: 'Bearer ' + sbKey, 'Content-Type': 'application/json' },
      body: '{}',
    });
    if (!res.ok) return null;
    const p = await res.json();
    return p && p.anmeldung_von ? p : null;
  } catch (e) {
    console.info('CS beta: nicht geladen —', e.message);
    return null;
  }
}

function datum(iso, lang) {
  const d = new Date(String(iso).slice(0, 10) + 'T00:00:00');
  return isNaN(d) ? '—' : d.toLocaleDateString(lang === 'en' ? 'en-GB' : 'de-DE', { day: 'numeric', month: 'long', year: 'numeric' });
}

/** HTML des Hinweises oder '' — Texte aus dem Wörterbuch der Seite (tx). */
export function betaHtml(p, tx, lang) {
  if (!p || !(p.kommt || p.offen)) return '';
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const ersetze = s => s
    .replace('{von}', datum(p.anmeldung_von, lang))
    .replace('{bis}', datum(p.anmeldung_bis, lang))
    .replace('{beta_bis}', datum(p.beta_bis, lang))
    .replace('{pct}', p.rabatt_pct == null ? '' : String(Number(p.rabatt_pct)))
    .replace('{rabatt_bis}', p.rabatt_bis ? datum(p.rabatt_bis, lang) : '');
  const rabatt = Number(p.rabatt_pct) > 0 && p.rabatt_bis ? ' ' + ersetze(tx.beta_r) : ' ' + tx.beta_danach;
  return `<div class="cs-beta" role="note">
    <div class="cs-beta-t">${esc(tx.beta_t)}</div>
    <div class="cs-beta-s">${esc(ersetze(p.offen ? tx.beta_offen : tx.beta_s) + rabatt)}</div>
  </div>`;
}
